var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.4374 22.0764H8.56409C6.31821 22.0764 4.4389 20.8016 4.22494 19.1333L1.6424 6.45544H20.3127L17.7766 19.1333C17.5626 20.8016 15.6833 22.0764 13.4374 22.0764Z","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.25934 11.8899V5.3123C7.25934 3.24597 8.93365 1.57166 11 1.57166C13.0663 1.57166 14.7406 3.24597 14.7406 5.3123V11.8899","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Cart.defaultProps = {"viewBox":"0 0 22 23","fill":"none"};

module.exports = Cart;

Cart.default = Cart;
